
import { RouterProvider } from 'react-router-dom';
import './App.css';
import { router } from './components/Router/Route';

function App() {
  return (
    <div className="container mx-auto bg-gradient-to-r from-white via-red-200 to-white ">
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;
